import { DisabledPrompt, Link, useWorkflowStep } from "@bcm-dev/bcms-vite";
import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import BillerView from "compid/shared/views/BillerView";
import TableView, { TableRowView } from "compid/shared/views/TableView";
import UIButton from "compid/ui/UIButton";
import { getDefault, getWorkflowSteps } from "compid/workflows/ReminderWorkflow";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function ReminderConfirmationPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ReminderConfirmationPage
 */

export default function ReminderConfirmationPage(props) {
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
  const reminder = workflowStep.read("reminder");
  const goToBillerDetails = () => workflowStep.navigate(`/billerDetails/details/${reminder.biller.id}`);
  const goToPayBills = () => workflowStep.navigate(`/payBills`);
  const daysToRemindMeInAdvanced = reminder.daysToRemindMeInAdvanced < 10 ?
    `0${reminder.daysToRemindMeInAdvanced}`
    : reminder.daysToRemindMeInAdvanced;
  const frequency = reminder.billReceivedFrequency.charAt(0).toUpperCase() + reminder.billReceivedFrequency.slice(1);

  const isDue = reminder.notificationDue && "is due";
  const isSent = reminder.notificationSent && "has been sent";
  const isNotPaid = reminder.notificationNotPaid && "isn't paid by the due date";

  const removeNotifications = isDue === false && isSent === false && isNotPaid === false;

  let notifications = [isDue, isSent, isNotPaid].reduce((result, item) => item !== false ? `${ result } ${ item },` : result, "");
  notifications = notifications.slice(0, notifications.length - 1);

  return (
    <PageView className="reminder-confirmation-page">
      <div className="flex-container flex-horizontal align-center space-between page-sub-header">
        <p className=" semi-bold-text flex-width">REMINDER CONFIRMATION</p>
        <DisabledPrompt>
          <Link>
            <div className="print-reminder-container flex-container flex-horizontal align-bottom">
              <SVGAsset id="PrinterIcon" className="left-icon set-width" />
              <p className="blue-text">Print</p>
            </div>
          </Link>
        </DisabledPrompt>
      </div>

      <PageLayoutContainer>
        <div className="flex-container flex-vertical flex-width all-center">
          <div className="flex-height flex-container flex-vertical upper-content-container">
            <BillerView biller={reminder.biller} />
          </div>

          <CenterColumnContainer>
            <div className="flex-height flex-container flex-vertical all-center">
              <SVGAsset id="CheckmarkIcon" className="green-icon" />
              <b className="gray-text">Your reminder is confirmed</b>
            </div>

            <TableView>
              <TableRowView label="Typical due date" data={reminder.typicalDueDate.format('M d')} />
              <TableRowView label="Typical amount due" data={reminder.amount.format()} />
              <TableRowView label="Frequency" data={frequency} />
              <TableRowView label="Remind me in advance" data={`${daysToRemindMeInAdvanced} days`} />
            </TableView>

            { !removeNotifications && <p className="sub-text">We'll send an email to <b>{reminder.email}</b> each time a payment { notifications }.</p> }

            <ButtonContainer className="form-button-container">
              <UIButton className="secondary-button" onClick={goToBillerDetails} dataPoint="Add_Reminder_Biller_Details">Go to biller details</UIButton>
              <UIButton className="primary-button" onClick={goToPayBills}>Go to pay bills</UIButton>
            </ButtonContainer>

          </CenterColumnContainer>

        </div>

      </PageLayoutContainer>
    </PageView>
  );
}